import { useMutation, useQuery, useQueryClient } from "react-query";
import useApiHelper from "../services/useApiHelper";

export default function useAreaGuidePostcodes(areaGuideId) {
  const staleTime = 10000;
  const queryClient = useQueryClient();
  const { get, post, put, del } = useApiHelper();

  const postcodes = useQuery(["areaGuidePostcodes", areaGuideId], () => get(`/AreaGuidePostcode/${areaGuideId}`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  const add = useMutation((postcode) => post(`/AreaGuidePostcode/${areaGuideId}`, postcode), {
    onSuccess: () => {
      queryClient.invalidateQueries(["areaGuidePostcodes", areaGuideId])
    },
  });

  // const update = useMutation((branch) => put(`/branch/${branch.id}`, branch), {
  //   onSuccess: (updatedBranch) => {
  //     queryClient.setQueryData(["areaGuidePostcodes", branchId], (currrentBranches) =>
  //       currrentBranches.map((branch) =>
  //         branch.id === updatedBranch.data.id ? updatedBranch.data : branch
  //       )
  //     );
  //   },
  // });

  const remove = useMutation((areaGuidePostcodeId) => del(`/AreaGuidePostcode/${areaGuidePostcodeId}`), {
    onSuccess: (_, areaGuidePostcodeId) => {
      queryClient.setQueryData(["areaGuidePostcodes", areaGuideId], (currentPostcodes) =>
        currentPostcodes.filter((postcode) => postcode.id !== areaGuidePostcodeId)
      );
    },
  });

  return {
    postcodes,
    add,
    // update,
    remove,
  };
}
